// Remembers the module the user last worked in so login / "start" CTAs can
// send returning users straight back to it instead of always /grimoire.
const STORAGE_KEY = 'lastModule';
const MODULE_PATHS = ['/grimoire', '/sigil'];
const DEFAULT_MODULE_PATH = '/grimoire';

export const rememberLastModule = (path) => {
  if (!MODULE_PATHS.includes(path)) return;
  try {
    localStorage.setItem(STORAGE_KEY, path);
  } catch {
    // Private mode / blocked storage — losing the preference is fine.
  }
};

export const getLastModulePath = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return MODULE_PATHS.includes(stored) ? stored : DEFAULT_MODULE_PATH;
  } catch {
    return DEFAULT_MODULE_PATH;
  }
};
